import React from "react";

export default function FilingAssistantMenu({
    company,
    isVisible,
    onAccurateFileName,
    onAccurateFolderName,
    onClickFileReportHistory,
    onClickViewUnallocatedFiles,
    checkDuplicatedFiles,
    onClickDeduperReportHistory,
}) {
    if (!isVisible) return null;

    return (
        <div className="miw100 menu op0 bsbb bw0px bbw5px bss bo3 zi1 bg1 shadow td250 pen p0-5rem pa t100 r0 df fdc">
            <label onClick={onAccurateFileName} className="bsbb wsn w100 td250 c4-hover p0-5rem ass cp">
                <span>Import Files</span>
            </label>
            <label onClick={onAccurateFolderName} className="bsbb w100 wsn td250 c4-hover p0-5rem ass cp">
                <span>Import Folders</span>
            </label>
            {company?.subscription?.toLowerCase() === "pro" ? (
                <p onClick={onClickFileReportHistory} className="bsbb w100 td250 c4-hover p0-5rem ass cp wsn">
                    Filing Assistant Manager
                </p>
            ) : null}
            <p onClick={onClickViewUnallocatedFiles} className="bsbb w100 td250 c4-hover p0-5rem ass cp wsn">
                View Unallocated Files
            </p>
            <p onClick={checkDuplicatedFiles} className="bsbb w100 td250 c4-hover p0-5rem ass cp wsn">
                Deduper
            </p>
            <p onClick={onClickDeduperReportHistory} className="bsbb w100 td250 c4-hover p0-5rem ass cp wsn">
                Deduper Reports
            </p>
        </div>
    );
}
